const testimonials = [
    {
        name: 'Priya S.',
        feedback: 'Amazing platform! Found my dream home with 121 Property.',
    },
    {
        name: 'Amit K.',
        feedback: 'As an agent, I get great visibility and leads. Highly recommend!',
    },
    {
        name: 'Ravi T.',
        feedback: 'Their home services saved me so much time. 5 stars!',
    },
];

const Testimonials = () => (
    <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
            <h2
                className="text-3xl font-bold mb-10"
                data-aos="fade-up"
                data-aos-duration="800"
            >What Our Clients Say</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((t, i) => (
                    <div
                        key={i}
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay={i * 150}
                        className="bg-white p-6 rounded-lg shadow"
                    >
                        <p className="text-gray-700 mb-4 italic">“{t.feedback}”</p>
                        <h4 className="text-md font-semibold">{t.name}</h4>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Testimonials;
